export default __webpack_public_path__ + "static/media/card1.d36b458f.png";